export function safeLink(value?:string){return value&&/^(\/(?![\\/])|https?:\/\/|mailto:|tel:)/i.test(value)?value:'';}
export function externalLink(value:string){return /^https?:\/\//i.test(value);}
// 同源上传图片由服务端按需生成小尺寸预览，其他来源按原图加载。
export function progressiveUrl(value:string){
  try{const url=new URL(value,location.origin);if(!url.pathname.startsWith('/uploads/'))return'';
    return `/api/public/image-preview?path=${encodeURIComponent(url.pathname)}`;
  }catch{return'';}
}
